import { render, staticRenderFns } from "./ProductCreateForm.vue?vue&type=template&id=bc95b160&scoped=true"
import script from "./ProductCreateForm.vue?vue&type=script&lang=js"
export * from "./ProductCreateForm.vue?vue&type=script&lang=js"
import style0 from "./ProductCreateForm.vue?vue&type=style&index=0&id=bc95b160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc95b160",
  null
  
)

export default component.exports